module.exports = __webpack_public_path__ + "sunsemweb/img/sr.a7c4b3df.png";